import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process/competencies',
  children: {
    groups: {
      path: 'groups',
    },
    import: {
      path: 'import/',
    },
    competencyId: {
      path: ':competencyId',
      children: {
        levels: {
          path: 'levels',
        },
        jobRoles: {
          path: 'job_roles',
        },
        settings: {
          path: 'settings',
        },
      },
    },
  },
} as const satisfies Location
